@import 'src/styles/variabels';

.root {
  margin: 0 0 0 1rem;
  height: 3rem;
  line-height: 1;
}
